import { SerialDescriptorForNullable2slcv65za9oog as SerialDescriptorForNullable } from '../internal/NullableSerializer.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SerialDescriptor2pelqekb5ic3a as SerialDescriptor } from './SerialDescriptor.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function getContextualDescriptor(_this__u8e3s4, descriptor) {
  var tmp0_safe_receiver = get_capturedKClass(descriptor);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = _this__u8e3s4.i11(tmp0_safe_receiver);
    tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.az();
  }
  return tmp;
}
function withContext(_this__u8e3s4, context) {
  return new (ContextDescriptor())(_this__u8e3s4, context);
}
function get_capturedKClass(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ContextDescriptor()) {
    tmp = _this__u8e3s4.q11_1;
  } else {
    if (_this__u8e3s4 instanceof SerialDescriptorForNullable()) {
      tmp = get_capturedKClass(_this__u8e3s4.m11_1);
    } else {
      tmp = null;
    }
  }
  return tmp;
}
var ContextDescriptorClass;
function ContextDescriptor() {
  if (ContextDescriptorClass === VOID) {
    class $ {
      constructor(original, kClass) {
        this.p11_1 = original;
        this.q11_1 = kClass;
        this.r11_1 = this.p11_1.h10() + '<' + this.q11_1.ff() + '>';
      }
      h10() {
        return this.r11_1;
      }
      equals(other) {
        var tmp0_elvis_lhs = other instanceof ContextDescriptor() ? other : null;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var another = tmp;
        return equals(this.p11_1, another.p11_1) && another.q11_1.equals(this.q11_1);
      }
      hashCode() {
        var result = this.q11_1.hashCode();
        result = imul(31, result) + getStringHashCode(this.r11_1) | 0;
        return result;
      }
      toString() {
        return 'ContextDescriptor(kClass: ' + toString(this.q11_1) + ', original: ' + toString(this.p11_1) + ')';
      }
      s11() {
        return this.p11_1.s11();
      }
      l11() {
        return this.p11_1.l11();
      }
      t11() {
        return this.p11_1.t11();
      }
      u11() {
        return this.p11_1.u11();
      }
      bz() {
        return this.p11_1.bz();
      }
      v11(index) {
        return this.p11_1.v11(index);
      }
      w11(name) {
        return this.p11_1.w11(name);
      }
      x11(index) {
        return this.p11_1.x11(index);
      }
      y11(index) {
        return this.p11_1.y11(index);
      }
      z11(index) {
        return this.p11_1.z11(index);
      }
    }
    initMetadataForClass($, 'ContextDescriptor', VOID, VOID, [SerialDescriptor()]);
    ContextDescriptorClass = $;
  }
  return ContextDescriptorClass;
}
//region block: exports
export {
  getContextualDescriptor as getContextualDescriptor2n1gf3b895yb8,
  withContext as withContext3ge61vpog00ae,
};
//endregion

//# sourceMappingURL=ContextAware.mjs.map
